import React, { useState } from 'react';
import './BotControls.css';

const BotControls = ({ running, onToggle, walletConnected }) => {
  const [isToggling, setIsToggling] = useState(false);
  const [botStats, setBotStats] = useState({
    uptime: '00:00:00',
    cycles: 0,
    lastAction: 'Aucune'
  });

  // Simuler le démarrage/arrêt du bot
  const handleToggle = async () => {
    if (!walletConnected) {
      alert('Veuillez d\'abord connecter votre wallet');
      return;
    }

    setIsToggling(true);
    
    // Simulation d'une requête API
    setTimeout(() => {
      onToggle(!running);
      setIsToggling(false);
      
      if (!running) {
        // Bot démarré
        setBotStats(prev => ({
          ...prev,
          lastAction: 'Bot démarré'
        }));
      } else {
        // Bot arrêté
        setBotStats(prev => ({
          ...prev,
          lastAction: 'Bot arrêté'
        }));
      }
    }, 1500);
  };

  // Simuler l'uptime
  React.useEffect(() => {
    let interval;
    if (running) {
      let seconds = 0;
      interval = setInterval(() => {
        seconds++;
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;
        
        setBotStats(prev => ({
          ...prev,
          uptime: `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`,
          cycles: prev.cycles + 1
        }));
      }, 1000);
    }
    
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [running]);

  return (
    <div className="bot-controls">
      <div className="controls-header">
        <h3>🤖 Contrôles du Bot</h3>
        <div className={`bot-status ${running ? 'active' : 'inactive'}`}>
          <div className="status-dot"></div>
          {running ? 'ACTIF' : 'INACTIF'}
        </div>
      </div>

      <div className="bot-info">
        <div className="info-grid">
          <div className="info-item">
            <span className="label">⏱️ Uptime:</span>
            <span className="value">{botStats.uptime}</span>
          </div>
          <div className="info-item">
            <span className="label">🔄 Cycles:</span>
            <span className="value">{botStats.cycles}</span>
          </div>
          <div className="info-item">
            <span className="label">📝 Dernière action:</span>
            <span className="value">{botStats.lastAction}</span>
          </div>
        </div>
      </div>

      <div className="control-buttons">
        <button 
          className={`main-control ${running ? 'stop' : 'start'}`}
          onClick={handleToggle}
          disabled={isToggling || !walletConnected}
        >
          {isToggling ? (
            <>
              <div className="spinner"></div>
              {running ? 'Arrêt...' : 'Démarrage...'}
            </>
          ) : (
            <>
              {running ? '⏹️ Arrêter le Bot' : '▶️ Démarrer le Bot'}
            </>
          )}
        </button>

        {running && (
          <div className="secondary-controls">
            <button className="secondary-btn pause-btn">
              ⏸️ Pause
            </button>
            <button className="secondary-btn restart-btn">
              🔄 Redémarrer
            </button>
          </div>
        )}
      </div>

      {!walletConnected && (
        <div className="warning-message">
          ⚠️ Connectez votre wallet pour contrôler le bot
        </div>
      )}

      <div className="bot-config">
        <h4>⚙️ Configuration V3.6</h4>
        <div className="config-grid">
          <div className="config-item">
            <span className="config-label">DCA:</span>
            <span className="config-value">Tous les -3%</span>
          </div>
          <div className="config-item">
            <span className="config-label">TP:</span>
            <span className="config-value">+1.5%</span>
          </div>
          <div className="config-item">
            <span className="config-label">Max DCA:</span>
            <span className="config-value">20 niveaux</span>
          </div>
          <div className="config-item">
            <span className="config-label">Cycle:</span>
            <span className="config-value">3 secondes</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BotControls;
